var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingLeftQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 81,
    viewBox: "0 0 102 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 81V45.6C60 32.8 64 22.6 72 15C80.2 7.19999 89.9 2.39998 101.1 0.599984V14.7C95.7 16.5 90.9 19.8 86.7 24.6C82.7 29.4 80.7 35.2 80.7 42H100.5V81H60ZM0.6 81V45.6C0.6 32.8 4.6 22.6 12.6 15C20.8 7.19999 30.5 2.39998 41.7 0.599984V14.7C36.3 16.5 31.5 19.8 27.3 24.6C23.3 29.4 21.3 35.2 21.3 42H41.1V81H0.6Z",
    fill: "#204B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLeftQuotes);
export default __webpack_public_path__ + "static/media/landingLeftQuotes.cc9c60f26b31d911d6ef4e3a99fbdb45.svg";
export { ForwardRef as ReactComponent };